import request from '@/utils/request'
import { v2Host } from '@/config/host'
import _ from 'lodash'

/**
 * http://playable.dev.com:8067/?doc=vmaker/template.go
 * 视频模板制作接口
 * @param {*}
 */

/**
  * 解析模板
  * @param {*} data
  */
export function templateParse(data) {
  return request({
    url: `${v2Host}/vmaker/template/parse`,
    method: 'post',
    data: data,
    timeout: 6000000
  })
}

/**
 * 模板创建
 * @param {*} data
 */
export function templateCreate(data) {
  return request({
    url: `${v2Host}/vmaker/template/create`,
    method: 'post',
    data: data
  })
}

export function templateUpdate(data) {
  return request({
    url: `${v2Host}/vmaker/template/update`,
    method: 'post',
    data: data
  })
}

/**
 * 模板删除
 * @param {*} data
 */
export function templateDelete(params) {
  const id = params.id
  params = _.omit(params, ['id'])
  return request({
    url: `${v2Host}/vmaker/template/delete?id=${id}`,
    method: 'post',
    data: params
  })
}

/**
 * 获取视频模板列表
 * @param {} params
 */
export function fetchTemplateList(params) {
  // 删除搜索表单辅助属性值
  delete params.ratios_type
  if (Number(params.industry_types) === 0) {
    delete params.industry_types
  }
  return request({
    url: `${v2Host}/vmaker/template/list`,
    method: 'get',
    params: params
  })
}

/**
 * 获取模板详情
 * @param {*} params
 */
export function fetchTemplateInfo(params) {
  return request({
    url: `${v2Host}/vmaker/template/info`,
    method: 'get',
    params: params
  })
}

export function fetchTemplateSetting(params) {
  return request({
    url: `${v2Host}/vmaker/template/setting`,
    method: 'get',
    params: params
  })
}

export function grateTemplate(params) {
  const id = params.id
  params = _.omit(params, ['id'])
  return request({
    url: `${v2Host}/vmaker/template/grant?id=${id}`,
    method: 'post',
    data: params
  })
}
